import { getNextQuery } from "./getNextQuery";
import manifestJson from "../../page-manifest.json";

export function getDynamiclyHref(_url: any) {
  function parseUrl(completePath: any) {
    const [path, QS = ""] = completePath.split("?");
    const nextQuery = getNextQuery(QS);
    return { href: nextQuery.length ? `${path}?${nextQuery}` : path, asPath: QS.length ? `${path}?${QS}` : path };
  }

  if (!_url) {
    return { href: "", asPath: "" };
  }
  // convet link from http to https
  const url = _url.replace(/^http:\/\//i, "https://");
  // external url
  if (url.indexOf("https://partsavatar.ca") === -1 && !url.startsWith("/")) {
    return { href: "", asPath: _url };
  }
  // home page
  if (url === "https://partsavatar.ca" || url === "https://partsavatar.ca/") {
    return { href: "/", asPath: "/" };
  }
  const relativeUrl = url.replace(/^(?:\/\/|[^/]+)*\//, "/");
  // check for old category page
  if (relativeUrl.indexOf("/category") === 0) {
    return parseUrl(relativeUrl);
  }
  // check for search page
  if (relativeUrl.indexOf("/search") === 0) {
    return parseUrl(relativeUrl);
  }
  // check for product page
  if (relativeUrl.indexOf("/product") === 0) {
    return parseUrl(relativeUrl);
  }
  // check for static page
  if (manifestJson[relativeUrl]) {
    return parseUrl(manifestJson[relativeUrl], relativeUrl);
  }
  // Todo: we can use relativeUrl here. substring is used for relative URL
  return parseUrl(relativeUrl);
  // check for canonicalPage page
}
